import React from 'react';
import Breadcrumb from '../../../Components/Breadcrumbs'
import { Box, Typography } from '@material-ui/core'
import useStyles from './style';

const ReleaseNotes = () => {
    const classes = useStyles();
    return (
    <>
      <Breadcrumb value={[{ 'Developer Hub': '/developer' }, { 'Release Notes': '/developer/release-notes' }]} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Release Notes</Typography>
        <Box className={classes.subTitle}>Release Notes will be added soon...</Box>
      </Box>
    </>
    );
};

export default ReleaseNotes;